import React from 'react';
const vendors = [{
  name: 'Ping Yang',
  cuisine: 'Thai',
  emoji: '🌶️',
  desc: 'Crispy egg over rice, pad thai, and signature tamarind crispy chicken — authentic Thai street flavors made fresh.',
  bg: '#2D6A4F',
  pattern: '#F2C94C' // yellow
}, {
  name: 'Alessie Café',
  cuisine: 'Coffee · Breakfast',
  emoji: '☕',
  desc: 'Made-from-scratch coffee, seasonal teas, fluffy waffles, and all your sweet breakfast favorites.',
  bg: '#C9903A',
  pattern: '#F5F0E8' // cream
}, {
  name: 'Donburi Rice Bowls',
  cuisine: 'Japanese',
  emoji: '🍱',
  desc: 'Japanese rice bowls built on a foundation of perfectly seasoned rice, tender slow-cooked meats, and fresh-cut vegetables.',
  bg: '#1B2C5E',
  pattern: '#5BADDE' // blue
}, {
  name: 'Xi-Cali',
  cuisine: 'Mexicali-Chinese Fusion',
  emoji: '🥢',
  desc: 'A one-of-a-kind fusion of Chinese culinary tradition and bold Mexican flavors — born in Mexicali, served here.',
  bg: '#7B4F2E',
  pattern: '#E8705A' // coral
}, {
  name: 'Coleta',
  cuisine: 'Brunch',
  emoji: '🍳',
  desc: 'Weekend brunch done right: French toast, pancakes, machaca, molletes, huevos rancheros, and chilaquiles that hit every time.',
  bg: '#E8541A',
  pattern: '#F2C94C' // yellow
}, {
  name: 'Barra 8',
  cuisine: 'Bar',
  emoji: '🍻',
  desc: "California wines, Mexican cerveza, and the best of San Diego's craft microbreweries — all under one roof.",
  bg: '#2A2A2A',
  pattern: '#C9903A' // gold
}, {
  name: 'Tacos La Ocho',
  cuisine: 'Sinaloa · Tacos',
  emoji: '🌮',
  desc: 'Sinaloa-style carne asada with hand-pressed tortillas, house salsas, USDA Choice ribeye, and tripitas. This is the real deal.',
  bg: '#E8705A',
  pattern: '#F5F0E8' // cream
}, {
  name: "Kiko's Place",
  cuisine: 'Baja Seafood',
  emoji: '🦪',
  desc: "Baja seafood straight from San Felipe — as seen on Netflix's Taco Chronicles. Ceviche, tostadas, cocktails, and a live oyster bar.",
  bg: '#5BADDE',
  pattern: '#1B2C5E' // navy
}, {
  name: "Poppy's & Cream",
  cuisine: 'Burgers · Shakes',
  emoji: '🍔',
  desc: 'Smash burgers, crispy fries with creamy spicy sauce, fire hot wings, and original milkshakes with a Tijuana twist.',
  bg: '#F2C94C',
  pattern: '#2A2A2A' // dark
}, {
  name: 'Carnitas Quiroga',
  cuisine: 'Michoacán · Carnitas',
  emoji: '🥩',
  desc: 'Generations of tradition in every bite. Authentic Michoacán-style carnitas made the time-honored way — slow, rich, and unforgettable.',
  bg: '#2D6A4F',
  pattern: '#F2C94C' // yellow
}];
export function Vendors() {
  return <section id="vendors" className="py-24 bg-brand-cream" data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        {/* Section Header */}
        <div className="max-w-3xl mb-16" data-id="element-95">
          <span className="inline-block font-display font-bold text-brand-orange tracking-widest uppercase text-sm mb-3" data-id="element-96">
            Our Community
          </span>
          <h2 className="font-display font-extrabold text-brand-dark text-4xl md:text-5xl mb-6 uppercase" data-id="element-97">
            Explore Our Marketplace
          </h2>
          <p className="text-brand-dark/80 text-lg leading-relaxed" data-id="element-98">
            Ten incredible vendors. Countless flavors. One roof. From Japanese
            donburi to Baja seafood, Sinaloa tacos to Michoacán carnitas — your
            next favorite meal is waiting.
          </p>
        </div>

        {/* Vendor Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-99">
          {vendors.map((vendor, idx) => <article key={idx} className="bg-white rounded-xl overflow-hidden shadow-[0_2px_8px_rgba(42,42,42,0.08)] hover:-translate-y-1 hover:shadow-[0_8px_24px_rgba(42,42,42,0.12)] transition-all duration-300 flex flex-col h-full" data-id="element-100">
              {/* Card Header (Colored with Pattern) */}
              <div className="relative h-32 flex flex-col justify-between p-4" style={{
            backgroundColor: vendor.bg
          }} data-id="element-101">
                {/* Diagonal Pattern Overlay */}
                <div className="absolute inset-0 opacity-[0.12]" style={{
              backgroundImage: `repeating-linear-gradient(45deg, ${vendor.pattern} 0px, ${vendor.pattern} 1px, transparent 0px, transparent 50%)`,
              backgroundSize: '12px 12px'
            }} data-id="element-102" />

                {/* Emoji */}
                <div className="relative z-10 text-4xl" data-id="element-103">{vendor.emoji}</div>

                {/* Cuisine Tag */}
                <div className="relative z-10 flex justify-end" data-id="element-104">
                  <span className="bg-white/90 backdrop-blur-sm text-brand-dark text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-none shadow-sm" data-id="element-105">
                    {vendor.cuisine}
                  </span>
                </div>
              </div>

              {/* Card Body */}
              <div className="p-6 flex-1 flex flex-col" data-id="element-106">
                <h3 className="font-display font-bold text-2xl text-brand-dark mb-3 uppercase" data-id="element-107">
                  {vendor.name}
                </h3>
                <p className="text-sm text-brand-dark/70 leading-relaxed flex-1" data-id="element-108">
                  {vendor.desc}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}